import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { LaddaModule } from 'angular2-ladda';
import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';
import { LoginComponent } from './views/login/login.component';
import { authInterceptorProviders } from './helper/auth.interceptor';
import { NavbtnModule } from './ui/navbtn/navbtn.module';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { JwtModule } from "@auth0/angular-jwt";
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';



export function tokenGetter() {
  return localStorage.getItem("reportauth");
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
       ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
       HttpClientModule,
       FormsModule,
      LaddaModule,
       NavbtnModule,
       JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
       
      },
    })
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
      LoginComponent,
    
     
   
   
  ],
 providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },authInterceptorProviders],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
